import type { ReactNode } from 'react';
import { Col, Row, Stack, SubHeading } from '@workramp/ui';
import { StyledCard } from './SettingsSidebarSubSectionCard.styles';

export const SettingsSidebarSubSectionCard = ({
  title,
  description,
  children,
}: {
  title: string;
  description?: ReactNode;
  children: ReactNode;
}) => (
  <StyledCard>
    <Stack size={4}>
      <Row justify="space-between">
        <Col>
          <SubHeading level="xl">{title}</SubHeading>
        </Col>
        {description && <Col xs="auto">{description}</Col>}
      </Row>
      <Stack size={4}>{children}</Stack>
    </Stack>
  </StyledCard>
);
